import { render, staticRenderFns } from "./ProjectGroupManagement.vue?vue&type=template&id=e2ce6528&scoped=true&"
import script from "./ProjectGroupManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGroupManagement.vue?vue&type=style&index=0&id=e2ce6528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce6528",
  null
  
)

export default component.exports